module.exports = __webpack_public_path__ + "img/hic-diseases-of-the-nervous-system-female.6fe8e4ca.png";